const r = {
  styleOverrides: {
    root: ({ theme: o }) => ({
      height: o.spacing(3.5),
      borderRadius: `${o.tokens.radius[4]} !important`,
      margin: o.spacing(0.5),
      color: o.palette.text.secondary,
      gap: o.spacing(1),
      "&:hover": {
        color: o.palette.text.body
      },
      "&.Mui-focusVisible": {
        color: o.palette.text.body
      },
      "&.Mui-selected": {
        color: o.palette.primary.main
      },
      "> svg": {
        color: o.palette.grey[400]
      }
    })
  }
};
export {
  r as menuItem
};
//# sourceMappingURL=menuItem2.mjs.map
